// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1QUjB","col":"styles_col__gFUFj"};